//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory6', {
//        templateUrl: 'views/components/views/textileModelCategory6/textileModelCategory6.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'textileModelCategory6Service', 'translateService', function ($stateParams, stateService, modalService, textileModelCategory6Service, translateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory6Keyno = $stateParams.textilemodelcategory6_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                textileModelCategory6LangNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('textilemodelcategory6lang', { textilemodelcategory6_keyno: vm.model.edit.textilemodelcategory6_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await textileModelCategory6Service.getTextileModelCategory6({ textilemodelcategory6_keyno: textileModelCategory6Keyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory6Service.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();		
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
